<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoSystems_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.053 4.947a.79.79 0 1 1-1.58 0 .79.79 0 0 1 1.58 0"
    />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16.21 4.947a3.948 3.948 0 1 1-7.895 0 3.948 3.948 0 0 1 7.895 0m-1.82 0a2.126 2.126 0 1 1-4.251 0 2.126 2.126 0 0 1 4.25 0"
        clip-rule="evenodd"
    />
    <path
        fill="currentColor"
        d="m4.894 4.158-.042.001h-.115A2.737 2.737 0 0 0 2 6.896v9.263a2.737 2.737 0 0 0 2.737 2.737h14.526A2.737 2.737 0 0 0 22 16.159V6.896a2.737 2.737 0 0 0-2.737-2.737h-.116l-.041-.001h-.527a.79.79 0 0 0 0 1.579h.244v.001h.44c.64 0 1.158.518 1.158 1.158v9.263c0 .64-.518 1.158-1.158 1.158H4.737a1.16 1.16 0 0 1-1.158-1.158V6.896c0-.64.518-1.158 1.158-1.158h.441v-.001h.769a.79.79 0 1 0 0-1.579zM9.105 19.949h5.79l.764 2.291a.658.658 0 0 1-.624.866h-6.07a.658.658 0 0 1-.624-.866z"
    />
    <path
        fill="currentColor"
        d="M6.452 7.316c.5 0 .943.295 1.222.71a5.52 5.52 0 0 0 4.59 2.448 5.52 5.52 0 0 0 4.701-2.62c.198-.318.533-.538.907-.538a.97.97 0 0 1 .97.97v5.451a2 2 0 0 1-2 2H7.159a2 2 0 0 1-2-2V8.61c0-.715.58-1.294 1.294-1.294"
    />
</svg>
